var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { CircleCross } from './circle-cross';
import { CircleCrossSmall } from './circle-cross-small';
import { CircleCrossLarge } from './circle-cross-large';
var cls = classNames('circle-bar-trail');
import Countup from 'react-countup';
import { toString } from 'lodash';
export var CircleTrailBarDefaultProps = {
  color: 'primary',
  insetValueColor: 'light',
  size: 'default',
  formatValue: function (value) {
    return toString(value);
  },
  rotation: 0,
  width: '80%'
};
export var CircleTrailBarHeights = {
  small: 16,
  default: 32,
  medium: 48,
  large: 80
};
export var CircleTrailBarValueSizes = {
  small: 12,
  default: 18,
  medium: 22,
  large: 48
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    transition: width 0.5s;\n    ", "\n  "], ["\n    position: relative;\n    transition: width 0.5s;\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      _width = _a._width,
      size = _a.size;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", ";\n      background: linear-gradient(to right, transparent 0%, ", " 100%);\n      height: ", "px;\n    "], ["\n      width: ", ";\n      background: linear-gradient(to right, transparent 0%, ", " 100%);\n      height: ", "px;\n    "])), _width, theme.COLOR(_color), CircleTrailBarHeights[size]);
  })
});
var CapStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n    display: flex;\n    top: 0;\n    transform: translate(50%, 0);\n    ", "\n  "], ["\n    position: absolute;\n    right: 0;\n    display: flex;\n    top: 0;\n    transform: translate(50%, 0);\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), CircleTrailBarHeights[size], CircleTrailBarHeights[size]);
  })
});
var CircleCrossStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (_a) {
    var rotation = _a.rotation;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      transition: transform 0.5s;\n      transform: rotate(", "deg);\n    "], ["\n      transition: transform 0.5s;\n      transform: rotate(", "deg);\n    "])), rotation);
  }, function (_a) {
    var clickable = _a.clickable,
      rotation = _a.rotation;
    return clickable && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "])));
  })
});
var CircleCrossSmallStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), CircleCrossStyles)
});
var CircleCrossLargeStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), CircleCrossStyles)
});
var ValueStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: absolute;\n    display: flex;\n    top: 0;\n    align-items: center;\n    font-weight: 500;\n    line-height: 1em;\n    ", "\n  "], ["\n    position: absolute;\n    display: flex;\n    top: 0;\n    align-items: center;\n    font-weight: 500;\n    line-height: 1em;\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      size = _a.size,
      _right = _a._right,
      _left = _a._left;
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      height: ", "px;\n      font-size: ", ";\n      color: ", ";\n      ", ";\n      ", ";\n    "], ["\n      height: ", "px;\n      font-size: ", ";\n      color: ", ";\n      ", ";\n      ", ";\n    "])), CircleTrailBarHeights[size], theme.FONT_SIZE(CircleTrailBarValueSizes[size]), theme.COLOR(_color), _right && "right: ".concat(_right), _left && "left: ".concat(_left));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Cap: styled.span.attrs(cls.attr('cap'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), CapStyles),
  CircleCross: styled(CircleCross)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), CircleCrossStyles),
  CircleCrossSmall: styled(CircleCrossSmall)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), CircleCrossSmallStyles),
  CircleCrossLarge: styled(CircleCrossLarge)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), CircleCrossLargeStyles),
  Value: styled.b.attrs(cls.attr('value'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
export var CircleTrailBar = function (props) {
  var className = props.className,
    color = props.color,
    size = props.size,
    rotation = props.rotation,
    width = props.width,
    showValue = props.showValue,
    formatValue = props.formatValue,
    value = props.value,
    insetValueColor = props.insetValueColor,
    showCountUp = props.showCountUp,
    onClick = props.onClick;
  var CIRCLES = {
    small: My.CircleCrossSmall,
    medium: My.CircleCross,
    default: My.CircleCross,
    large: My.CircleCrossLarge
  };
  var valueColor = props.valueColor || color;
  var valueIsInset = width.match(/[0-9]+%/) && parseInt(width) > 50;
  var CircleComponent = props.circleComponent;
  var Circle = CircleComponent ? function (props) {
    return React.createElement(CircleComponent, __assign({}, props, {
      size: CircleTrailBarHeights[size]
    }));
  } : CIRCLES[size];
  return React.createElement(My.Container, {
    _color: color,
    _width: width,
    size: size,
    className: cls.name(className)
  }, React.createElement(My.Cap, {
    size: size
  }, React.createElement(Circle, {
    rotation: rotation,
    clickable: !!onClick,
    onClick: onClick,
    colors: {
      fill: color
    }
  }), value !== undefined && value !== null && (showValue || showCountUp) && React.createElement(My.Value, {
    _right: valueIsInset && "".concat(8 + CircleTrailBarHeights[size], "px"),
    _left: !valueIsInset && "".concat(4 + CircleTrailBarHeights[size], "px"),
    size: size,
    _color: valueIsInset ? insetValueColor : valueColor
  }, showCountUp ? React.createElement(Countup, {
    duration: 0.5,
    formattingFn: formatValue,
    start: 0,
    end: value
  }) : formatValue(value))));
};
CircleTrailBar.defaultProps = CircleTrailBarDefaultProps;
CircleTrailBar.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;